var Width;
(function (Width) {
  Width["BLOCK"] = "block";
  Width["AUTO"] = "auto";
})(Width || (Width = {}));

export { Width };
//# sourceMappingURL=width.mjs.map
